export default __webpack_public_path__ + "static/toolbar-create-new-action-light-mode-40077f1e3664c41204580d7c3ce179ac.mp4";